import { defineComponent, reactive, toRefs, watch, onMounted } from "vue";
import { useRouter } from "vue-router";
export default defineComponent({
  name: "LAYOUT",

  setup() {
    const router = useRouter();
    const state = reactive({
      active: "/home",
      includeRoutes: ["ABOUT"]
    });
    watch(() => state.active, val => {
      router.push(val);
    });
    onMounted(() => {
      state.active = router.currentRoute.value.path;
    });
    return { ...toRefs(state)
    };
  }

});